import {connect} from '../../app/connect';
import {getChecklistDetail, getProjectId} from '../../app/selectors';
import React from 'react';
import Label from '@adsk/bim360-matrix-react-label';
import ChecklistEntityBlock from './ChecklistEntityBlock';
import PropTypes from 'prop-types';
import {getDeeplinkUrl} from '../../utils/checklist-helper';
import i18n from '../../utils/i18n';

const ChecklistCreatedFrom = ({checklistDetails, projectId, container}) =>
  checklistDetails && (
    <div className="ChecklistCreatedFrom">
      <div className="LinkedDocumentInlineEdit__label">
        <Label>{i18n.t('new.createdFrom')} </Label>
      </div>
      <ChecklistEntityBlock
        instance={checklistDetails.instance}
        section={checklistDetails.section}
        item={checklistDetails.item}
        deeplinkUrl={getDeeplinkUrl(checklistDetails.instance, checklistDetails.section, projectId)}
        container={container}
      />
    </div>
  );

ChecklistCreatedFrom.displayName = 'ChecklistCreatedFrom';
ChecklistCreatedFrom.propTypes = {
  checklistDetails: PropTypes.object.isRequired,
  projectId: PropTypes.string.isRequired,
  container: PropTypes.object
};

const mapStateToProps = state => ({
  checklistDetails: getChecklistDetail(state),
  projectId: getProjectId(state)
});

export default connect(mapStateToProps)(ChecklistCreatedFrom);
